import page from './Arcitle.vue';

export default page;



// WEBPACK FOOTER //
// ./src/components/page/blog/article/index.ts